import CustomSequencingSettingsCard from "./CustomSequencingSettingsCard";

export default CustomSequencingSettingsCard;
